<div class="flex flex-col h-full flex-1 min-h-0">

  <p-table [scrollable]="true" [size]="'small'" [value]="outgoingCreditNotes()" scrollHeight="flex">
    <ng-template #header>
      <tr>
        <th *dev pResizableColumn pSortableColumn="number">Uuid
        </th>
        <th pResizableColumn pSortableColumn="number">{{ 'invoice.number' | translate }}
          <p-sortIcon field="number"/>
        </th>
        <th pResizableColumn pSortableColumn="date">{{ 'credit-note.date' | translate }}
          <p-sortIcon field="date"/>
        </th>
        <th pResizableColumn>{{ 'invoice.recipient' | translate }}</th>
        <th pResizableColumn pSortableColumn="format">{{ 'invoice.format' | translate }}
          <p-sortIcon field="format"/>
        </th>
        <th pResizableColumn>{{ 'invoice.downloaded' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-creditNote>
      <tr>
        <td *dev>{{ creditNote.uuid }}</td>
        <td>{{ creditNote.number }}</td>
        <td>{{ creditNote.date | date : 'dd/MM/yyyy' }}</td>
        <td>{{ creditNote.recipient?.name }}</td>
        <td>{{ creditNote.format }}</td>
        <td>{{ creditNote.downloaded ? ('common.yes' | translate) : ('common.no' | translate) }}</td>
        <td class="flex justify-end gap-1">
          <elcia-button (onClick)="downloadCreditNotePeppol(creditNote)" [icon]="'download'" [variant]="'text'"/>
          <elcia-button (onClick)="downloadAttachments(creditNote)" [icon]="'attachment'" [variant]="'text'"/>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
